/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreDiniEditAliases {
  ACTION_DELETE_SCORE_DINI = 'action-delete-score-dini',
  ACTION_NEW_SCORE_DINI = 'action-new-score-dini',
  ACTION_REFERENCE_SCORE_DINI = 'action-reference-score-dini',
  ACTION_RELEASE_SCORE_DINI = 'action-release-score-dini',
  AUTOCOMPLETE_ACCOMPANYING_PARTICIPATION = 'autocomplete-accompanying-participation',
  AUTOCOMPLETE_ACTIVITY = 'autocomplete-activity',
  AUTOCOMPLETE_BODY_HYGIENE = 'autocomplete-body-hygiene',
  AUTOCOMPLETE_DRUG_THERAPY = 'autocomplete-drug-therapy',
  AUTOCOMPLETE_ELIMINATION = 'autocomplete-elimination',
  AUTOCOMPLETE_FOOD_AND_HYDRATION = 'autocomplete-food-and-hydration',
  AUTOCOMPLETE_MOBILITY_AND_WALKING = 'autocomplete-mobility-and-walking',
  AUTOCOMPLETE_MUCOSAL_CUTANEOUS_INTEGRITY = 'autocomplete-mucosal-cutaneous-integrity',
  AUTOCOMPLETE_OXYGENATION = 'autocomplete-oxygenation',
  AUTOCOMPLETE_RANGE_CONTROLS = 'autocomplete-range-controls',
  AUTOCOMPLETE_SUPPORT_AND_SUPPORT_NETWORK = 'autocomplete-support-and-support-network',
  FETCH_ACCOMPANYING_PARTICIPATION = 'fetch-accompanying-participation',
  FETCH_ACTIVITY = 'fetch-activity',
  FETCH_BODY_HYGIENE = 'fetch-body-hygiene',
  FETCH_DRUG_THERAPY = 'fetch-drug-therapy',
  FETCH_ELIMINATION = 'fetch-elimination',
  FETCH_FOOD_AND_HYDRATION = 'fetch-food-and-hydration',
  FETCH_MOBILITY_AND_WALKING = 'fetch-mobility-and-walking',
  FETCH_MUCOSAL_CUTANEOUS_INTEGRITY = 'fetch-mucosal-cutaneous-integrity',
  FETCH_OXYGENATION = 'fetch-oxygenation',
  FETCH_RANGE_CONTROLS = 'fetch-range-controls',
  FETCH_SUPPORT_AND_SUPPORT_NETWORK = 'fetch-support-and-support-network',
  FIELD_ACCOMPANYING_PARTICIPATION = 'field-accompanying-participation',
  FIELD_ACTIVITY = 'field-activity',
  FIELD_BODY_HYGIENE = 'field-body-hygiene',
  FIELD_DRUG_THERAPY = 'field-drug-therapy',
  FIELD_ELIMINATION = 'field-elimination',
  FIELD_FOOD_AND_HYDRATION = 'field-food-and-hydration',
  FIELD_MOBILITY_AND_WALKING = 'field-mobility-and-walking',
  FIELD_MUCOSAL_CUTANEOUS_INTEGRITY = 'field-mucosal-cutaneous-integrity',
  FIELD_OXYGENATION = 'field-oxygenation',
  FIELD_RANGE_CONTROLS = 'field-range-controls',
  FIELD_SETUP_DATE = 'field-setup-date',
  FIELD_SUPPORT_AND_SUPPORT_NETWORK = 'field-support-and-support-network',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_ONE = 'form-one',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_SETUP_DATE = 'input-setup-date',
  MAPPER_ACCOMPANYING_PARTICIPATION = 'mapper-accompanying-participation',
  MAPPER_ACTIVITY = 'mapper-activity',
  MAPPER_BODY_HYGIENE = 'mapper-body-hygiene',
  MAPPER_DRUG_THERAPY = 'mapper-drug-therapy',
  MAPPER_ELIMINATION = 'mapper-elimination',
  MAPPER_FOOD_AND_HYDRATION = 'mapper-food-and-hydration',
  MAPPER_MOBILITY_AND_WALKING = 'mapper-mobility-and-walking',
  MAPPER_MUCOSAL_CUTANEOUS_INTEGRITY = 'mapper-mucosal-cutaneous-integrity',
  MAPPER_OXYGENATION = 'mapper-oxygenation',
  MAPPER_RANGE_CONTROLS = 'mapper-range-controls',
  MAPPER_SUPPORT_AND_SUPPORT_NETWORK = 'mapper-support-and-support-network',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  SCORE_DINI_ADD_LAYOUT = 'score-dini-add-layout',
  TEXT_ACCOMPANYING_PARTICIPATION = 'text-accompanying-participation',
  TEXT_ACTIVITY = 'text-activity',
  TEXT_BODY_HYGIENE = 'text-body-hygiene',
  TEXT_DRUG_THERAPY = 'text-drug-therapy',
  TEXT_ELIMINATION = 'text-elimination',
  TEXT_FOOD_AND_HYDRATION = 'text-food-and-hydration',
  TEXT_MOBILITY_AND_WALKING = 'text-mobility-and-walking',
  TEXT_MUCOSAL_CUTANEOUS_INTEGRITY = 'text-mucosal-cutaneous-integrity',
  TEXT_OXYGENATION = 'text-oxygenation',
  TEXT_RANGE_CONTROLS = 'text-range-controls',
  TEXT_SUPPORT_AND_SUPPORT_NETWORK = 'text-support-and-support-network',
  WIZARD = 'wizard',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { ScoreDiniEditAliases };
